import Swiper from 'swiper';
import 'swiper/css';

class BlogPostRelatedArticles {
  constructor(component) {
    this.refs = {
      slider: '.js-slider',
    };
    
    this.dom = {
      $component: component,
      $slider: component.querySelector(this.refs.slider),
    };
    
    this.state = {
    };

    this.mount();

    this.init();
  }

  mount() {
    const { dom } = this;
    console.log('mounting BlogPostRelatedArticles');
  }

  init() {
    const { dom, state } = this;
    if (!dom.$slider) return;

    this.slider = new Swiper(dom.$slider, {
      slidesPerView: 1.4,
      spaceBetween: 21,
      slidesOffsetAfter: 15,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
          slidesOffsetAfter: 0,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 25,
          slidesOffsetAfter: 0,
        }
      }
    });
  }
}

const $blogPostRelatedArticles = document.querySelector('.js-blog-post-related-articles');
if ($blogPostRelatedArticles) new BlogPostRelatedArticles($blogPostRelatedArticles);